import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";
interface ScriptureSearchFormProps {
  searchTopic: string;
  setSearchTopic: (value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
}
const ScriptureSearchForm: React.FC<ScriptureSearchFormProps> = ({
  searchTopic,
  setSearchTopic,
  handleSubmit,
  isLoading
}) => {
  return <form onSubmit={handleSubmit} className="max-w-2xl mx-auto">
      <div className="flex flex-col sm:flex-row gap-3">
        <input type="text" placeholder="Ex. Love, Patience, Anxiety, etc..." value={searchTopic} onChange={e => setSearchTopic(e.target.value)} className="flex-1 h-12 px-4 bg-gray-50 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-heaven-gold/30 focus:border-transparent rounded-lg py-[15px]" />
        <Button type="submit" className="bg-black text-white hover:bg-gray-800 h-12 px-6 rounded-lg w-full sm:w-auto" disabled={isLoading}>
          {isLoading ? <>
              <Loader2 className="mr-2 h-4 w-4 animate-spin" />
              Searching...
            </> : <>
              <Send className="mr-2 h-4 w-4" />
              Send
            </>}
        </Button>
      </div>
    </form>;
};
export default ScriptureSearchForm;